<template>
<audio-feature-modal-template
    :showModal="showModal"
    :closeModal="cleanFormAndCloseModal"
    modalType="Update"
    :featureName="featureName"
>

<template v-slot:languages>
<div class="flex lang-box mt-5">
    <a v-for="(lang, index) in languages" href="#" @click.prevent="changeLanguage(lang)" :key="index"
    :class="{active:(form.current_language == lang), disabled:langDisabled(lang)}">{{ showFallbackLang(lang) }}</a>
</div>
</template>

<template v-slot:feature-form>
<div class="grid grid-cols-1 md:grid-cols-2">
    <section class="border border-gray-800 p-3">

        <div class="">
            <div class="flex">
                <label>Title for audio feature</label>
                <span v-if="errors().title" class="errormessage">{{ errors().title }}</span>
            </div>
            <input class="input-black" type="text" id="audio_title" v-model="form.feature_audio_files[form.current_language].title"
            @input="$emit('update:titleForAudioFeature', $event.target.value)">
        </div>

        <div class="flex">
            <label>Add audio file</label>
            <span v-if="errors().file" class="errormessage">{{ errors().file }}</span>
        </div>
        <div class="upload-box">
            <span>
                <i class="icon-upload mr-2"></i><a href="##" @click.prevent="changeUploadBoxState('audio_feature_audio')">Upload another file from media library</a>
            </span>

            <audio ref="player" class="mx-auto my-2" controls>
                <source :src="audioFileName()" type="audio/mpeg">
              Your browser does not support the audio element.
            </audio>

            <span>{{ audioFileName() }}</span>
        </div>

    </section>

    <section class="border border-gray-800 p-3">
        <div class="flex">
            <label>Add background image</label>
            <span v-if="errors().file" class="errormessage">{{ errors().file }}</span>
        </div>
        <RecommendedAspectRatio uploadBoxType="audio-feature-preview" />
        <div class="upload-box">

            <div v-if="!form.feature_audio_preview_images[form.current_language].from_media_library_id">
                <span>
                    <i class="icon-upload mr-2"></i><a href="##" @click.prevent="changeUploadBoxState('audio_feature_background_image')">Upload from media library</a>
                </span>
                <span class="block">{{ backgroundFileName() }}</span>
            </div>

            <div v-if="form.feature_audio_preview_images[form.current_language].from_media_library_id">
                <img :src="form.feature_audio_preview_images[form.current_language].loaded_file_path" class="logo-img">
            </div>
        </div>

    </section>

</div>
</template>

<template v-slot:buttons>
<button v-if="!form.processing" class="btn btn-gradient" @click="updateAudioFeature"><i class="save mr-1"></i>Update</button>
<button v-else class="btn btn-gradient"><Spinner/></button>
<span v-if="form.recentlySuccessful" class="ml-3 text-white">Updated</span>
</template>

</audio-feature-modal-template>
</template>

<script>
import AudioFeatureModalTemplate from './AudioFeatureModalTemplate';
import CreateFileInsideFeatureAudioSection from '@/Pages/Station/Partials/Features/AudioGuide/CreateFileInsideFeatureAudioSection';
import RecommendedAspectRatio from '@/Pages/Media/RecommendedAspectRatio';
import { showFallbackLang } from '@/Pages/GlobalHelpers';
import Spinner from '@/UI/Spinner';

export default {
    components:{
        AudioFeatureModalTemplate,
        CreateFileInsideFeatureAudioSection,
        RecommendedAspectRatio,
        Spinner
    },
    props: [
        'showModal',
        'closeModal',
        'featureName',
        'changeUploadBoxState',
        'current_edit_feature_id'
    ],
    data(){
        return {
            languages: this.$page.props.tour.data.languages,
            form: this.$inertia.form({
                _method: 'POST',
                feature_id: null,
                feature_audio_files: this.generateLanguagesForAudioInAudioGuideFeature(),
                feature_audio_preview_images: this.generatePreviewImagesInAudioGuideFeature(),
                fallback_language: this.$page.props.tour.data.fallback_language,
                current_language: this.$page.props.tour.data.fallback_language,
            }),
        }
    },
    mounted(){
        this.changeLanguage(this.$page.props.tour.data.fallback_language);
    },
    watch:{
        current_edit_feature_id: function (newState, oldState){
            if(newState != null){
                this.current_feature = this.$page.props.station.data.features
                .filter( el => el.id == newState)[0];
                this.changeCurrentFeatureForm();
            } else {
                this.current_feature = null;
            }
        },
        'form.current_language'(newState) {
          this.changeCurrentFeatureForm();
        }
    },
    methods:{
        updateAudioFeature() {
            this.form.post(route('feature.update', this.$page.props.station.data.id), {
              preserveScroll: true,
              onSuccess: () => {
                this.current_feature = this.$page.props.station.data.features
                .filter( el => el.id == this.current_edit_feature_id)[0];
              },
            });
        },
        errors(){
            return this.$page.props.errors;
        },
        audioFileName(){
            if(this.form.feature_audio_files[this.form.current_language].from_media_library_id)
            {
                return this.form.feature_audio_files[this.form.current_language].loaded_file_path
            } else {
                return this.form.feature_audio_files[this.form.current_language].file &&
                this.form.feature_audio_files[this.form.current_language].file.name;
            }
        },
        backgroundFileName(){
            return this.form.feature_audio_preview_images[this.form.current_language].file &&
            this.form.feature_audio_preview_images[this.form.current_language].file.name;
        },
        changeLanguage(lang){
            if(this.langDisabled(lang))
            {
                return;
            }
            this.form.current_language = lang;
        },
        langDisabled(lang){
            if(lang == this.form.current_language)
            {
                return false;
            }
            if(this.form.feature_audio_files[this.form.fallback_language].file != null)
            {
                return false;
            }
            if(this.form.feature_audio_files[this.form.fallback_language].loaded_file_path.length > 0)
            {
                return false;
            }
            return true;
        },
        showFallbackLang:showFallbackLang,
        generateLanguagesForAudioInAudioGuideFeature(){
            const obj = {};
            const langs = this.$page.props.tour.data.languages;
            langs.forEach(el => {
                obj[el] = {
                    'title' : '',
                    'file' : null,
                    'copyright_text' : '',
                    'copyright_link' : '',
                    'loaded_file_path': '',
                    'from_media_library_id': null
                }
            })

            return obj;
        },
        generatePreviewImagesInAudioGuideFeature(){
            const obj = {};
            const langs = this.$page.props.tour.data.languages;
            langs.forEach(el => {
                obj[el] = {
                    'file': null,
                    'copyright_text' : '',
                    'copyright_link' : '',
                    'loaded_file_path': '',
                    'from_media_library_id': null
                }
            })

            return obj;
        },
        changeCurrentFeatureForm(){
            this.form.feature_id = this.current_feature.id;

            this.form.feature_audio_files[this.form.current_language].title = this.current_feature.title.localized_text[this.form.current_language];

            this.form.feature_audio_files[this.form.current_language].from_media_library_id = this.current_feature.audio_file.filter(el => el.language == this.form.current_language)[0].id;

            this.form.feature_audio_files[this.form.current_language].loaded_file_path = this.current_feature.audio_file.filter(el => el.language == this.form.current_language)[0].first_file_path;

            this.form.feature_audio_preview_images[this.form.current_language].from_media_library_id = this.current_feature.image_file && this.current_feature.image_file.filter(el => el.language == this.form.current_language)[0] && this.current_feature.image_file.filter(el => el.language == this.form.current_language)[0].id;
            this.form.feature_audio_preview_images[this.form.current_language].loaded_file_path = this.current_feature.image_file && this.current_feature.image_file.filter(el => el.language == this.form.current_language)[0] && this.current_feature.image_file.filter(el => el.language == this.form.current_language)[0].first_file_path;

            this.$refs.player.load();
        },
        cleanFormAndCloseModal(){
            this.form.current_language = this.$page.props.tour.data.fallback_language;
            this.form.feature_audio_files = this.generateLanguagesForAudioInAudioGuideFeature();
            this.form.feature_audio_preview_images = this.generatePreviewImagesInAudioGuideFeature();
            this.closeModal();
        }
    }
}
</script>
